import React from 'react'
// import { Routes, Route } from "react-router-dom"
// import { Link } from 'react-router-dom';
// import { Link } from 'react-router-dom';
// import { Link } from 'react-router-dom';
import Navbar from '../../Components/Navbar';

const Ecommercewebsite = () => {
  return (
    <div>

      <Navbar />

      <h2>TAH Hardware projects goes here</h2>
    </div>
  )
}

export default Ecommercewebsite